var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.4002C8 4.63288 9.43269 3.2002 11.2 3.2002L20.8 3.2002C22.5673 3.2002 24 4.63288 24 6.4002L24 28.8002L16 24.8002L8 28.8002L8 6.4002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFolder);
export default __webpack_public_path__ + "static/media/favorite-folder.bca20251846e46341e005a66c27243f1.svg";
export { ForwardRef as ReactComponent };